import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IUIReducer } from './types';
import { hasAcknowledgedEntry } from '../../utils/localStorage';
import isLikelyInAppBrowser from '../../utils/isLikelyInAppBrowser';

const initialState: IUIReducer = {
  sideMenuOpen: false,
  darkMode: false,
  cssBreakpoint: 'not-set',
  screenWidth: 0,
  screenHeight: 0,
  visualViewport: null,
  consentDecided: hasAcknowledgedEntry(),
  inAppBrowser: isLikelyInAppBrowser(),
};

const ui = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setSideMenuOpen: (state, action: PayloadAction<boolean>) => {
      state.sideMenuOpen = action.payload;
    },
    setDarkMode: (state, action: PayloadAction<boolean>) => {
      state.darkMode = action.payload;
    },
    setScreenProperties: (
      state,
      action: PayloadAction<{
        cssBreakpoint: string;
        screenWidth: number;
        screenHeight: number;
        visualViewport: { height: number } | null;
      }>
    ) => {
      state.cssBreakpoint = action.payload.cssBreakpoint;
      state.screenWidth = action.payload.screenWidth;
      state.screenHeight = action.payload.screenHeight;
      state.visualViewport = action.payload.visualViewport;
    },
    // Analytics is anonymous+cookieless and is never gated on this — the
    // entry screen's proceed button acknowledges the SAFETY notice, and
    // utils/localStorage.setEntryAcknowledged() persists that (best-effort,
    // separately from the analytics opt-out preference) BEFORE this is
    // dispatched (see GDPR.tsx) — this just flips the flag that hides the
    // entry screen.
    recordConsentDecision: (state) => {
      state.consentDecided = true;
    },
  },
});

export const {
  recordConsentDecision,
  setDarkMode,
  setScreenProperties,
  setSideMenuOpen,
} = ui.actions;

export default ui;
